/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
var CollapseAllButton = (function() {
  let hideElements = undefined;
  let replace = undefined;
  let triggerEvents = undefined;
  CollapseAllButton = class CollapseAllButton {
    static initClass() {
  
      hideElements = function(el) {
        const target = $(el.data('target'));
        return target.find('[data-toggle="collapse"]:contains("Collapse")').click();
      };
  
      replace = function(el) {
        const target = $(el.data('target'));
        return el.replaceWith(ExpandAllButton.create({target}));
      };
  
      triggerEvents = el => $(document).trigger({
        type: 'collapse:collapsed',
        element: $(el.data('target'))
      });
    }
    constructor() {
      $(document).on('click', '[data-collapse-all]', function(e) {
        const el = $(e.currentTarget);
        hideElements(el);
        replace(el);
        return triggerEvents(el);
      });
    }

    static create(options) {
      /*
      Required attributes:
        * target
      */
      return $('<button>')
        .attr('data-collapse-all', true)
        .text('Collapse All')
        .addClass('btn btn-sm btn-danger')
        .data('target', options.target);
    }
  };
  CollapseAllButton.initClass();
  return CollapseAllButton;
})();

global.CollapseAllButton = CollapseAllButton;
export default CollapseAllButton;